import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { FiMail, FiLock, FiUser, FiArrowRight } from 'react-icons/fi'
import { FaFacebook } from 'react-icons/fa'
import toast from 'react-hot-toast'
import useAuthStore from '../stores/authStore'
import { getFacebookAuthUrl } from '../services/api'

export default function RegisterPage() {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [passwordConfirmation, setPasswordConfirmation] = useState('')
    const { register, isLoading } = useAuthStore()
    const navigate = useNavigate()

    const handleFacebookLogin = async () => {
        try {
            const response = await getFacebookAuthUrl()
            window.location.href = response.data.url
        } catch (error) {
            toast.error(window.t('neuspeshno_svarzvane_s_facebook'))
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (password !== passwordConfirmation) {
            toast.error(window.t('parolite_ne_savpadat'))
            return
        }

        const result = await register({
            name,
            email,
            password,
            password_confirmation: passwordConfirmation,
        })

        if (result.success) {
            toast.success(window.t('profilat_e_sazdaden_uspeshno'))
            navigate('/profile')
        } else {
            toast.error(result.error)
        }
    }

    return (
        <div className="min-h-screen pt-16 flex items-center justify-center px-4 py-12">
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-accent-500/10 rounded-full blur-3xl" />
                <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-primary-500/10 rounded-full blur-3xl" />
            </div>

            <div className="card p-8 w-full max-w-md relative">
                <div className="text-center mb-8">
                    <h1 className="text-2xl font-bold text-white">{window.t('sazdavane_na_profil')}</h1>
                    <p className="text-gray-400 mt-2">{window.t('zapochnete_da_zapazvate_lyubim')}</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-5">
                    <div>
                        <label className="label">{window.t('dve_imena')}</label>
                        <div className="relative">
                            <FiUser className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" />
                            <input
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="input pl-12"
                                placeholder={window.t('ivan_ivanov')}
                                required
                            />
                        </div>
                    </div>

                    <div>
                        <label className="label">{window.t('imeyl')}</label>
                        <div className="relative">
                            <FiMail className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" />
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="input pl-12"
                                placeholder="you@example.com"
                                required
                            />
                        </div>
                    </div>

                    <div>
                        <label className="label">{window.t('parola')}</label>
                        <div className="relative">
                            <FiLock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" />
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="input pl-12"
                                placeholder="••••••••"
                                required
                                minLength={8}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="label">{window.t('potvardete_parolata')}</label>
                        <div className="relative">
                            <FiLock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" />
                            <input
                                type="password"
                                value={passwordConfirmation}
                                onChange={(e) => setPasswordConfirmation(e.target.value)}
                                className="input pl-12"
                                placeholder="••••••••"
                                required
                            />
                        </div>
                    </div>

                    <div className="text-sm text-gray-400">
                        {window.t('vaznikna_greshka_pri_zarezhdane_na_tazi_sektsiya')}{' '}
                        <a href="#" className="text-primary-400 hover:text-primary-300">{window.t('usloviya_za_polzvane')}</a>
                        {' '}и{' '}
                        <a href="#" className="text-primary-400 hover:text-primary-300">{window.t('politika_za_poveritelnost')}</a>
                    </div>

                    <button
                        type="submit"
                        className="btn-primary w-full"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white"></div>
                        ) : (
                            <>
                                {window.t('sazdavane_na_profil')}
                                <FiArrowRight className="w-4 h-4 ml-2" />
                            </>
                        )}
                    </button>

                    <div className="relative my-6">
                        <div className="absolute inset-0 flex items-center">
                            <div className="w-full border-t border-gray-700"></div>
                        </div>
                        <div className="relative flex justify-center text-sm">
                            <span className="px-2 bg-gray-900 text-gray-400">{window.t('ili_se_registrirayte_s')}</span>
                        </div>
                    </div>

                    <button
                        type="button"
                        onClick={handleFacebookLogin}
                        className="w-full flex items-center justify-center gap-2 px-4 py-2 border border-blue-600/50 hover:bg-blue-600/10 text-white rounded-lg transition-colors"
                    >
                        <FaFacebook className="w-5 h-5 text-blue-500" />
                        Facebook
                    </button>
                </form>

                <p className="text-center text-gray-400 mt-6">
                    {window.t('veche_imate_profil')}{' '}
                    <Link to="/login" className="text-primary-400 hover:text-primary-300 font-medium">
                        {window.t('vhod')}
                    </Link>
                </p>
            </div>
        </div>
    )
}
